import { filterRecommendedArticles } from "./SwipeArticleUtils";

const STORAGE_KEY = (publication: string) =>
  `flow_swipe_articles_${publication}`;
const STORAGE_EXPIRY_KEY = (publication: string) =>
  `flow_swipe_articles_expiry_${publication}`;
export const EXPIRY_TIME = 30 * 60 * 1000; // 30 minutes

const fetchArticlesIfNeeded = async ({
  currentArticleId,
  setNextArticle,
  publication,
  sectionId,
}: {
  currentArticleId: number;
  setNextArticle: Function;
  publication: string;
  sectionId: number;
}) => {
  const storedArticles = localStorage.getItem(STORAGE_KEY(publication));
  const storedExpiry = localStorage.getItem(STORAGE_EXPIRY_KEY(publication));
  const currentTime = Date.now();

  if (storedArticles && storedExpiry && currentTime < parseInt(storedExpiry)) {
    let articles = JSON.parse(storedArticles);
    articles = filterRecommendedArticles(articles, currentArticleId);
    if (articles.length > 0) {
      setNextArticle(articles[0]);
      return;
    }
  }

  try {
    const response = await fetch(
      `/api/flow_swipe?publication=${publication}&number=${sectionId}`,
    );
    const data = await response.json();

    if (data.articles?.length > 0) {
      const filteredArticles = filterRecommendedArticles(
        data.articles,
        currentArticleId,
      );
      if (filteredArticles.length > 0) {
        localStorage.setItem(
          STORAGE_KEY(publication),
          JSON.stringify(filteredArticles),
        );
        localStorage.setItem(
          STORAGE_EXPIRY_KEY(publication),
          (currentTime + EXPIRY_TIME).toString(),
        );
        setNextArticle(filteredArticles[0]);
      }
    }
  } catch (error) {
    console.error("Error fetching swipe articles:", error);
  }
};

export default fetchArticlesIfNeeded;
